export default (state) => {
    return state.batch;
}



// WEBPACK FOOTER //
// ./src/ReduxRequests/State/batchState.ts